import {HttpClient} from "../../service/httpClient/HttpClient";

export class LanguageService {

    constructor() {
        this.httpClient = new HttpClient()
    }


    getLanguageList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `languages`,
                {page, size}
            ).then(resolve).catch(reject)
        })
    }

    getAvailableLanguageList() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `languages/available`
            ).then(resolve).catch(reject)
        })
    }

    getLanguageInfo(languageId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `languages/${languageId}`
            ).then(resolve).catch(reject)
        })
    }

    addNewLanguage(name, code, direction, calendarType, enabled, isDefault) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `languages`,
                {
                    name, code, direction, calendarType, enabled, isDefault
                }
            ).then(resolve).catch(reject)
        })
    }

    updateLanguage(id, name, code, direction, calendarType, enabled, isDefault) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `languages/${id}`,
                {
                    name, code, direction, calendarType, enabled, isDefault
                }
            ).then(resolve).catch(reject)
        })
    }
}